// extracted by mini-css-extract-plugin
export default {"utcLabelSkeleton":"FlowDailyMetrics_utcLabelSkeleton__2v4HL"};